import { usePassportProvider } from "@/context";
import { trackEvent } from "@analytics";
import { useCallback, useState } from "react";
import { mutate } from "swr";
import { acceptReferral } from "../app/_lib/apis/referral";

export const useReferralAcceptance = () => {
  const [isAccepting, setIsAccepting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { passportClient } = usePassportProvider();

  const handleAcceptReferral = useCallback(
    async (referralCode: string, campaignId?: number) => {
      setIsAccepting(true);
      setError(null);

      try {
        const token = await passportClient.getAccessToken();
        if (!token) {
          setError("Authentication required");
          return false;
        }
        const result = await acceptReferral(token, referralCode);

        if (result) {
          if (campaignId) {
            try {
              mutate(`/v1/quests/campaign/${campaignId}/referral-status`);
            } catch (error) {
              console.error("Error mutating referral status", error);
            }
          }
          trackEvent({
            component: "Effect",
            action: "Succeeded",
            extras: {
              control: "ReferralAcceptance",
              section: "ReferralFlow",
              userJourney: "Referral",
              referralCode,
              campaignId,
            },
          });
          return true;
        }

        throw new Error("Failed to accept referral");
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : "Unknown error";
        setError(errorMessage);

        trackEvent({
          component: "Effect",
          action: "Failed",
          extras: {
            control: "ReferralAcceptance",
            section: "ReferralFlow",
            userJourney: "Referral",
            referralCode,
            campaignId,
            error: errorMessage,
          },
        });

        return false;
      } finally {
        setIsAccepting(false);
      }
    },
    [passportClient],
  );

  return {
    handleAcceptReferral,
    isAccepting,
    error,
  };
};
